'use strict';

export default function($stateProvider) {
  'ngInject';
  $stateProvider
    .state('violations-code-edit', {
      url: '/violation/code/edit/:id',
      template: '<violations-code-edit></violations-code-edit>',
      authenticate: true
    });
}



// WEBPACK FOOTER //
// ./client/app/violations/code-edit/violations-code-edit.routes.js